export default __webpack_public_path__ + "static/driver-behavior-monitoring-89b2ff818ca05d5ae794d50b3dcc6fec.jpg";